// Converts the old Parenting Time Planner (agreements/{id}/planner/schedule)
// into a rotation. The old planner drew a fixed two-week template on the dummy
// dates Sun 2 Jan – Sat 15 Jan 2022 (components/ParentalPlanner.vue), and split
// any block that wrapped from week 2 back to week 1 into two pieces.

import parseISO from 'date-fns/parseISO'
import { MIN_PER_WEEK } from './weekMath.js'
import { positionFromInterval } from './splitTimeblock.js'
import { blankRotation } from './rotationTemplates.js'

const WEEKS = 2
const CYCLE = WEEKS * MIN_PER_WEEK
const WEEK_ONE_MONDAY = new Date(2022, 0, 3)
const OLD_CYCLE_START = -1440
const OLD_CYCLE_END = CYCLE - 1440

function toDate(value) {
  if (value && typeof value.toDate === 'function') return value.toDate()
  if (typeof value === 'string') return parseISO(value)
  return new Date(value)
}

function cycleMinutes(value) {
  const d = toDate(value)
  const mins = Math.round((d - WEEK_ONE_MONDAY) / 60000)
  const endOfDay = d.getMinutes() === 59 ? 1 : 0
  return mins + endOfDay
}

function newTransition(oldTransition, partner) {
  const other = partner === 'A' ? 'B' : 'A'
  if (oldTransition === 'dropOff') return `${partner}_drops`
  if (oldTransition === 'pickUp') return `${other}_picks`
  return null
}

export function rotationFromPlanner(events, anchorDate) {
  const blocks = (events || [])
    .filter((e) => e && e.start && e.end)
    .map((e) => ({
      partner: e.class === 'partner2' ? 'B' : 'A',
      start: cycleMinutes(e.start),
      end: cycleMinutes(e.end),
      transition: e.transition,
      transitionDetails: e.transitionDetails || '',
      eventNo: e.eventNo,
    }))
    .filter((b) => b.end > b.start)

  if (!blocks.length) return null

  const heads = blocks.filter((b) => b.start === OLD_CYCLE_START)
  const merged = blocks.filter((b) => b.start !== OLD_CYCLE_START).map((b) => {
    if (b.end !== OLD_CYCLE_END) return b
    const headIndex = heads.findIndex((h) => h.partner === b.partner && h.eventNo === b.eventNo)
    if (headIndex === -1) return b
    const [head] = heads.splice(headIndex, 1)
    return { ...b, end: b.end + (head.end - head.start) }
  })

  const rotation = blankRotation(anchorDate)
  merged.concat(heads).forEach((b) => {
    const { weekIndex, ...position } = positionFromInterval(b.start, b.end, WEEKS)
    rotation.weeks[weekIndex].events.push({
      partner: b.partner,
      ...position,
      transition: newTransition(b.transition, b.partner),
      transitionDetails: b.transitionDetails,
    })
  })
  return rotation
}
